module.exports = __webpack_public_path__ + "../resources/img/installer_process1.ff4e220e.png";